import axios from "axios";
import { appUrl } from "../../../../../../utils/config";

// ============================================================================
// DOCUMENTS APIs - All APIs for Documents management
// ============================================================================

/**
 * Fetch Project Documents
 * @param {string} projectId - Project ID (same as main dashboard projectId field, e.g., "AR - LDD")
 * @returns {Promise<Object>} Response with documents array
 * 
 * Payload: { documentType: "Project Documents", projectId: string }
 * Response: { status: true, data: [{ documentId, documentName, documentType, uploadDate, s3Url }] }
 */
export const fetchProjectDocumentsAPI = async (projectId) => {
  // COMMENTED OUT - Actual API call
  // const apiBaseUrl = `${appUrl}/${localStorage.getItem("appName")}/${localStorage.getItem("network")}/${localStorage.getItem("collabType")}/${localStorage.getItem("roleName")}`;
  // try {
  //   const response = await axios.post(`${apiBaseUrl}/fetchDocuments`, {
  //     documentType: "Project Documents",
  //     projectId: projectId
  //   });
  //   return response.data;
  // } catch (error) {
  //   console.error("Error fetching project documents:", error);
  //   throw error;
  // }

  return { status: true, data: [], message: "No project documents available" };
};

/**
 * Fetch Tech Transfer Documents
 * @param {string} projectId - Project ID (same as main dashboard projectId field, e.g., "AR - LDD")
 * @returns {Promise<Object>} Response with documents array
 * 
 * Payload: { documentType: "Tech Transfer Documents", projectId: string }
 * Response: { status: true, data: [{ documentId, documentName, documentType, uploadDate, s3Url }] }
 */
export const fetchTechTransferDocumentsAPI = async (projectId) => {
  // COMMENTED OUT - Actual API call
  // const apiBaseUrl = `${appUrl}/${localStorage.getItem("appName")}/${localStorage.getItem("network")}/${localStorage.getItem("collabType")}/${localStorage.getItem("roleName")}`;
  // try {
  //   const response = await axios.post(`${apiBaseUrl}/fetchDocuments`, {
  //     documentType: "Tech Transfer Documents",
  //     projectId: projectId
  //   });
  //   return response.data;
  // } catch (error) {
  //   console.error("Error fetching tech transfer documents:", error);
  //   throw error;
  // }

  return { status: true, data: [], message: "No tech transfer documents available" };
};

/**
 * Fetch Campaign Documents
 * @param {string} campaignId - Campaign ID (e.g., "TRY12345")
 * @returns {Promise<Object>} Response with documents array
 * 
 * Payload: { documentType: "Campaign Documents", campaignId: string }
 * Response: { status: true, data: [{ documentId, documentName, documentType, uploadDate, s3Url }] }
 */
export const fetchCampaignDocumentsAPI = async (campaignId) => {
  // COMMENTED OUT - Actual API call
  // const apiBaseUrl = `${appUrl}/${localStorage.getItem("appName")}/${localStorage.getItem("network")}/${localStorage.getItem("collabType")}/${localStorage.getItem("roleName")}`;
  // try {
  //   const response = await axios.post(`${apiBaseUrl}/fetchDocuments`, {
  //     documentType: "Campaign Documents",
  //     campaignId: campaignId
  //   });
  //   return response.data;
  // } catch (error) {
  //   console.error("Error fetching campaign documents:", error);
  //   throw error;
  // }

  return { status: true, data: [], message: "No campaign documents available" };
};

/**
 * Fetch Master Documents
 * @param {number} batchId - Batch ID
 * @param {string} operation - Operation (e.g., "B", "D", "I", "All")
 * @returns {Promise<Object>} Response with documents array
 * 
 * Payload: { documentType: "Master Documents", batchId: number, operation: string }
 * Response: { status: true, data: [{ documentId, documentName, documentType, version, uploadDate, s3Url }] }
 */
export const fetchMasterDocumentsAPI = async (batchId, operation = 'All') => {
  // COMMENTED OUT - Actual API call
  // const apiBaseUrl = `${appUrl}/${localStorage.getItem("appName")}/${localStorage.getItem("network")}/${localStorage.getItem("collabType")}/${localStorage.getItem("roleName")}`;
  // try {
  //   const response = await axios.post(`${apiBaseUrl}/fetchDocuments`, {
  //     documentType: "Master Documents",
  //     batchId: batchId,
  //     operation: operation
  //   });
  //   return response.data;
  // } catch (error) {
  //   console.error("Error fetching master documents:", error);
  //   throw error;
  // }

  return { status: true, data: [], message: "No master documents available" };
};

/**
 * Download Document from S3
 * @param {string} s3Url - S3 URL of the document
 * @param {number} documentId - Document ID
 * @param {string} documentName - Document name for download
 * @returns {Promise<Object>} Response with file data
 * 
 * Payload: { schrockenCustomFileID: number }
 * Response: { status: true, fileName: string, fileData: { type: "Buffer", data: [byte array] } }
 */
export const downloadDocumentAPI = async (s3Url, documentId, documentName) => {
  // COMMENTED OUT - Actual API call
  // const apiBaseUrl = `${appUrl}/${localStorage.getItem("appName")}/${localStorage.getItem("network")}/${localStorage.getItem("collabType")}/${localStorage.getItem("roleName")}`;
  // try {
  //   const response = await axios.post(`${apiBaseUrl}/downloadCustomFile`, {
  //     schrockenCustomFileID: documentId
  //   });
  //   return response.data;
  // } catch (error) {
  //   console.error("Error downloading document:", error);
  //   throw error;
  // }

  // Static response - Simulate file download
  // In real implementation, this would return actual file data from S3
  // Response structure: { status: true, fileName: string, fileData: { type: "Buffer", data: [byte array] } }
  return {
    status: true,
    fileName: documentName || "document.pdf",
    fileData: {
      type: "Buffer",
      data: [] // Byte array - actual response contains full file data as array of numbers
    }
  };
};

// Upload Document
export const uploadDocumentAPI = async (projectId, documentData) => {
  // COMMENTED OUT - Actual API call
  // const apiBaseUrl = `${appUrl}/${localStorage.getItem("appName")}/${localStorage.getItem("network")}/${localStorage.getItem("collabType")}/${localStorage.getItem("roleName")}`;
  // try {
  //   const formData = new FormData();
  //   formData.append('file', documentData.file);
  //   formData.append('documentType', documentData.documentType);
  //   const response = await axios.post(`${apiBaseUrl}/uploadDocument/${projectId}`, formData);
  //   return response.data;
  // } catch (error) {
  //   console.error("Error uploading document:", error);
  //   throw error;
  // }

  // Return static success response
  return {
    success: true,
    message: "Document uploaded successfully",
    data: { id: Date.now(), ...documentData },
  };
};

// Delete Document
export const deleteDocumentAPI = async (documentId) => {
  // COMMENTED OUT - Actual API call
  // const apiBaseUrl = `${appUrl}/${localStorage.getItem("appName")}/${localStorage.getItem("network")}/${localStorage.getItem("collabType")}/${localStorage.getItem("roleName")}`;
  // try {
  //   const response = await axios.delete(`${apiBaseUrl}/deleteDocument/${documentId}`);
  //   return response.data;
  // } catch (error) {
  //   console.error("Error deleting document:", error);
  //   throw error;
  // }

  // Return static success response
  return {
    success: true,
    message: "Document deleted successfully",
  };
};

